module.exports = __webpack_public_path__ + "static/media/discounts.4450f3e9.png";